import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url({ type, period }) {
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_BALANCES || '/admin/balances')
  },
  parse(raw = {}, payload = { type: '' }) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        data: { total: '-' },
        currency: 'XOF',
      }
    }

    const data = raw.data || {}
    const key = payload.type || 'totalBalance'

    return { 
      statusCode: 200, 
      data: { total: data[key] !== undefined ? data[key] : '-' } 
    }
  },
}
